import axios from 'axios';
import store from '../store';

axios.interceptors.response.use(null, error => {
  const status = { status: error.response.status };
  const errorObject = Object.assign(status);
  store.commit('setError', errorObject);
  return Promise.reject(error);
});
